













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/database';

@Component
export default class Notes extends Vue {
    private notesText: string = '';

    get notes() {
        this.notesText = this.$store.getters.getNotes;
        return this.$store.getters.getNotes;
    }

    private async createNotes() {
        const db = firebase.database();
        const notesRef = db.ref(`logistics/notes/text`);

        try {
            await notesRef.set(this.notesText);
            this.$store.dispatch('setNotes', this.notesText);
        } catch (e) {
            throw e;
        } finally {
            this.$emit('close');
        }
    }
}
